import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** The host's router never sees this app's history writes (opening an
 * automation, selecting an action), so the host learns about them here. */
export const LOCATION_CHANGE_EVENT = "automation-ui:location-change";

export const useAnnounceLocation = (): void => {
  const location = useLocation();
  useEffect(() => {
    window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
  }, [location]);
};
